import { render, staticRenderFns } from "./CourseConfig.vue?vue&type=template&id=7a95f432&scoped=true&"
import script from "./CourseConfig.vue?vue&type=script&lang=js&"
export * from "./CourseConfig.vue?vue&type=script&lang=js&"
import style0 from "./CourseConfig.vue?vue&type=style&index=0&id=7a95f432&scoped=true&lang=css&"
import style1 from "./CourseConfig.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a95f432",
  null
  
)

export default component.exports